"use client";

import { cn } from "@frontend/shared/lib/utils";
import { ArrowLeft } from "lucide-react";
import { forwardRef } from "react";
import { KioskButton, type KioskButtonProps } from "./KioskButton";

interface KioskBackButtonProps
  extends Omit<
    KioskButtonProps,
    "variant" | "size" | "fullWidth" | "children"
  > {
  iconSize?: number;
}

export const KioskBackButton = forwardRef<
  HTMLButtonElement,
  KioskBackButtonProps
>(({ className, iconSize, ...props }, ref) => {
  return (
    <KioskButton
      ref={ref}
      variant="outline"
      aria-label="Go back"
      fullWidth={false}
      size="lg"
      className={cn("!p-0 aspect-square flex-none flex mr-auto", className)}
      {...props}
    >
      <ArrowLeft className="h-4 md:h-5" />
    </KioskButton>
  );
});

KioskBackButton.displayName = "KioskBackButton";
